import { isDefined } from "@clipboard-health/util-ts";
import { useEffect, useState } from "react";

function calculateSecondsLeft(endTime: number): number {
  const remainingMs = endTime - Date.now();
  return Math.max(0, Math.ceil(remainingMs / 1000));
}

interface TimeoutTimerOptions {
  initialEndTime: number;
}
/**
 * This hook is used to count down to a specific time.
 * @param options.initialEndTime - The time to count down to (in unix timestamp).
 *
 * Use useCountdownTimer() instead if you want to count down from a specific number of seconds.
 */
export function useTimeoutTimer(options: TimeoutTimerOptions) {
  const { initialEndTime } = options;
  const [secondsLeft, setSecondsLeft] = useState<number>(calculateSecondsLeft(initialEndTime));

  useEffect(() => {
    const update = () => {
      setSecondsLeft(calculateSecondsLeft(initialEndTime));
    };

    update();
    const timerInterval = setInterval(() => {
      update();
      if (Date.now() >= initialEndTime) {
        clearInterval(timerInterval);
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, [initialEndTime]);

  return {
    countdownIsLoading: isDefined(initialEndTime) && secondsLeft > 0,
    secondsLeft,
  };
}
